<div class="ord-container" [class.ord-loading]="ordersLoading">
  <!-- Performance Header -->
  <div class="ord-perf-header">
    <span class="ord-perf-title">{{ 'companies.orders_tab.order_performance' | translate }}</span>
    <div class="ord-view-controls">
      <button class="ord-view-btn"
              [matMenuTriggerFor]="locationMenu"
              (menuOpened)="onLocationMenuOpened()"
              type="button">
        <app-svg-icon svgIcon="filter-cc" class="ord-view-icon"></app-svg-icon>
        <span>
          <ng-container *ngIf="ordersLocationId === 'all'">
            {{ 'companies.orders_tab.all_locations' | translate }}
          </ng-container>
          <ng-container *ngIf="ordersLocationId !== 'all'">
            {{ getOrdersLocationName(ordersLocationId) }}
          </ng-container>
        </span>
        <mat-icon class="ord-view-caret">expand_more</mat-icon>
      </button>
      <mat-menu #locationMenu="matMenu" class="ord-view-menu">
        <div class="ord-view-menu-header">
          <button mat-menu-item type="button"
                  (click)="onOrdersLocationChange('all')"
                  [class.active]="ordersLocationId === 'all'">
            {{ 'companies.orders_tab.all_locations' | translate }}
          </button>
        </div>
        <div class="ord-view-menu-list">
          <button mat-menu-item type="button"
                  *ngFor="let loc of (customer?.locations || [])"
                  (click)="onOrdersLocationChange(loc.id!)"
                  [class.active]="ordersLocationId === loc.id">
            {{ loc.name }}
          </button>
        </div>
      </mat-menu>
    </div>
  </div>

  <div class="ord-loader-overlay" *ngIf="ordersLoading">
    <div class="ord-loader-spinner"></div>
  </div>

  <!-- KPI Cards -->
  <div class="ord-kpi-row">
    <div class="ord-kpi-card">
      <span class="ord-kpi-label">{{ 'companies.orders_tab.total_orders' | translate }}</span>
      <span class="ord-kpi-value">{{ filteredKpi?.total_orders ?? 0 }}</span>
      <div class="ord-kpi-trend">
        <span class="ord-trend-badge" [ngClass]="ordersTrendClass">{{ ordersTrendText }}</span>
        <span class="ord-trend-text">{{ 'companies.orders_tab.vs_previous_year' | translate }}</span>
      </div>
    </div>
    <div class="ord-kpi-card">
      <span class="ord-kpi-label">{{ 'companies.orders_tab.total_order_value' | translate }}</span>
      <span class="ord-kpi-value">
        {{ (filteredKpi?.total_sales != null ? filteredKpi!.total_sales : 0) | number:'1.2-2' }} €
      </span>
      <div class="ord-kpi-trend">
        <span class="ord-trend-badge" [ngClass]="ordersTrendClass">{{ ordersTrendText }}</span>
        <span class="ord-trend-text">{{ 'companies.orders_tab.vs_previous_year' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Chart Area: shows current-year monthly order value bar chart.
       Falls back to an illustration when no data exists (noOrdersChartData() returns true). -->
  <div class="ord-chart-card">
    <span class="ord-chart-title">{{ 'companies.orders_tab.total_orders_value_per_month' | translate }}</span>
    <app-chart *ngIf="!noOrdersChartData()"
      type="bar"
      [data]="chartData"
      [options]="chartOptions">
    </app-chart>
    <div class="no-chart" *ngIf="noOrdersChartData()">
      <img src="assets/icones/no-chart.svg" alt="chart">
      <span>{{ 'companies.orders_tab.not_enough_data' | translate }}</span>
    </div>
  </div>

  <!-- Stats Rows -->
  <div class="ord-stats-block">
    <div class="ord-stat-row">
      <span class="ord-stat-label">{{ 'companies.orders_tab.peak_ordering_period' | translate }}</span>
      <div class="ord-stat-data">
        <span class="ord-stat-value">{{ filteredKpi?.peak ?? '--' }}</span>
        <ng-container *ngIf="filteredKpi?.peakDeltaPct != null">
          <span class="ord-trend-badge ord-stat-delta-badge"
            [ngClass]="recapHelpers.statDeltaClass(filteredKpi?.peakDeltaPct ?? null)">
            <span *ngIf="recapHelpers.statDeltaArrow(filteredKpi?.peakDeltaPct ?? null) as arrow"
              class="ord-stat-arrow"
              [class.ord-stat-arrow-negative]="(filteredKpi?.peakDeltaPct ?? 0) < 0"
              aria-hidden="true">{{ arrow }}</span>
            {{ recapHelpers.formatStatDeltaPct(filteredKpi?.peakDeltaPct ?? null) }}
          </span>
          <span class="ord-stat-vs">{{ 'companies.orders_tab.vs_last_year' | translate }}</span>
        </ng-container>
      </div>
    </div>
    <div class="ord-stat-row">
      <span class="ord-stat-label">{{ 'companies.orders_tab.avg_items_x_order' | translate }}</span>
      <div class="ord-stat-data">
        <span class="ord-stat-value">
          {{ filteredKpi?.avgItems != null ? (filteredKpi!.avgItems | number:'1.1-1') : '--' }}
        </span>
        <ng-container *ngIf="filteredKpi?.avgItemsDeltaPct != null">
          <span class="ord-trend-badge ord-stat-delta-badge"
            [ngClass]="recapHelpers.statDeltaClass(filteredKpi?.avgItemsDeltaPct ?? null)">
            <span *ngIf="recapHelpers.statDeltaArrow(filteredKpi?.avgItemsDeltaPct ?? null) as arrow"
              class="ord-stat-arrow"
              [class.ord-stat-arrow-negative]="(filteredKpi?.avgItemsDeltaPct ?? 0) < 0"
              aria-hidden="true">{{ arrow }}</span>
            {{ recapHelpers.formatStatDeltaPct(filteredKpi?.avgItemsDeltaPct ?? null) }}
          </span>
          <span class="ord-stat-vs">{{ 'companies.orders_tab.vs_last_year' | translate }}</span>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="ord-divider"></div>

  <!-- Recent Orders -->
  <div class="ord-recent-section">
    <span class="ord-recent-title">{{ 'companies.orders_tab.recent_orders' | translate }}</span>

    <ng-container *ngIf="!ordersLoading; else recentOrdersLoading">
      <ng-container *ngIf="recentOrdersGrouped.length; else noRecentOrders">
        <div class="ord-recent-group" *ngFor="let group of recentOrdersGrouped; let gi = index">
          <div class="ord-recent-group-header" (click)="toggleRecentOrdersGroup(gi)">
            <span class="ord-recent-group-label">{{ group.label }}</span>
            <mat-icon class="ord-recent-group-chevron"
              [class.ord-recent-group-chevron-collapsed]="group.collapsed">
              expand_less
            </mat-icon>
          </div>

          <ng-container *ngIf="!group.collapsed">
            <div class="ord-order-card" *ngFor="let order of group.items">
              <div class="ord-order-main">
                <div class="ord-order-info">
                  <div class="ord-order-name-row">
                    <span class="ord-order-name">{{ order.name }}</span>
                    <span class="status-badge ord-order-status"
                      [ngStyle]="recapHelpers.getStatusStyles(recapHelpers.getRecentOrderStatus(order))">
                      {{ recapHelpers.getStatusTranslation(recapHelpers.getRecentOrderStatus(order)) }}
                    </span>
                  </div>
                  <div class="ord-order-meta">
                    <span>{{ order.date_order | date: 'dd/MM/yyyy' }}</span>
                    <ng-container *ngIf="order.items_count != null">
                      <span class="ord-meta-dot">•</span>
                      <span>{{ order.items_count }} {{ 'companies.orders_tab.items' | translate }}</span>
                    </ng-container>
                    <ng-container *ngIf="getOrderShippingApartment(order) as shippingApartment">
                      <span class="ord-meta-dot">•</span>
                      <span>{{ 'customers.orders_tab.shipping_at' | translate }} {{ shippingApartment }}</span>
                    </ng-container>
                  </div>
                </div>
                <span class="ord-order-amount">{{ (order.total_amount ?? order.amount_untaxed ?? order.amount_total ?? 0) | number:'1.2-2' }} €</span>
                <button class="ord-order-more-btn" type="button"
                  [matMenuTriggerFor]="orderActionsMenu">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #orderActionsMenu="matMenu" class="ord-order-actions-menu">
                  <button mat-menu-item type="button" (click)="openOrderInNewTab(order.id)">
                    <mat-icon>north_east</mat-icon>
                    <span>{{ 'companies.orders_tab.go_to_order' | translate }}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </ng-container>
        </div>

        <button class="ord-view-all-btn" (click)="viewAllOrders()">
          <span>{{ 'companies.orders_tab.view_all_orders' | translate }}</span>
          <mat-icon class="ord-view-all-icon">north_east</mat-icon>
        </button>
      </ng-container>
    </ng-container>

    <ng-template #recentOrdersLoading>
      <div class="ord-recent-loader">
        <div class="ord-loader-spinner"></div>
      </div>
    </ng-template>

    <ng-template #noRecentOrders>
      <div class="ord-empty-card">
        <img src="assets/icones/no-orders.svg" alt="" class="ord-empty-illustration">
        <span class="ord-empty-text">{{ 'companies.orders_tab.no_orders_yet' | translate }}</span>
      </div>
    </ng-template>
  </div>
</div>
